import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StringEncNotEnabled, StringE2EEnabled, StringLocalEncEnabled } from '@/Constants/Strings';
import { observer } from 'mobx-react-lite';
import { Title, Text } from '../../PreferencesComponents/Content';
import PreferencesGroup from '../../PreferencesComponents/PreferencesGroup';
import PreferencesSegment from '../../PreferencesComponents/PreferencesSegment';
import EncryptionEnabled from './EncryptionEnabled';
import { useApplication } from '@/Components/ApplicationProvider';
import { c } from 'ttag';
const Encryption = () => {
    const app = useApplication();
    const hasUser = app.hasAccount();
    const hasPasscode = app.hasPasscode();
    const isEncryptionEnabled = app.isEncryptionAvailable();
    const encryptionStatusString = hasUser
        ? StringE2EEnabled()
        : hasPasscode
            ? StringLocalEncEnabled()
            : StringEncNotEnabled();
    return (_jsx(PreferencesGroup, { children: _jsxs(PreferencesSegment, { children: [_jsx(Title, { children: c('B6.Preferences.Security.Title').t `Encryption` }), _jsx(Text, { children: encryptionStatusString }), isEncryptionEnabled && _jsx(EncryptionEnabled, {})] }) }));
};
export default observer(Encryption);
